import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { API_SETTINGS } from './API_SETTINGS';
import { Learner } from '../models/Learner';
import { catchError, tap, map } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

const apiUrl = API_SETTINGS.API_URL + 'Learner';

@Injectable({
  providedIn: 'root'
})
export class ApiLearnerService {

  constructor(private http: HttpClient) { }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getLearners(): Observable<Learner[]> {
    const url = apiUrl + '/GetLearners';
    return this.http.post<Learner[]>(url, httpOptions).pipe(
      catchError(this.handleError<Learner[]>('GetLearners'))
    );
  }

  getLearnerById(id: number): Observable<Learner> {
    const url = `${apiUrl}/GetLearnerById/${id}`;
    return this.http.get<Learner>(url).pipe();
  }

  getLearnerByCustomerId(id: number): Observable<Learner[]> {
    const url = `${apiUrl}/GetLearnersByCustomerId/${id}`;
    return this.http.get<Learner[]>(url).pipe();
  }

  
  getLearnerByEmail(email: string): Observable<Learner> {
    const url = `${apiUrl}/GetLearnerByEmail/${email}`;
    return this.http.get<Learner>(url).pipe();
  }

  getLearnerByUsername(username: string): Observable<Learner> {
    const url = `${apiUrl}/GetLearnerByUsername/${username}`;
    return this.http.get<Learner>(url).pipe();
  }

  addLearner (learner: Learner): Observable<Learner> {  
    const url = apiUrl + '/PostLearner';
    return this.http.post<Learner>(url, learner, httpOptions).pipe(
      catchError(this.handleError<Learner>('addLearner'))
    )
  }
  
  updateLearner (id: number, Learner: any): Observable<Learner>{
    const url = `${apiUrl}/PutLearner/${id}`;
    return this.http.put(url, Learner, httpOptions).pipe(
      tap((ProjectRes: Learner) => true ), //console.log()),
      catchError(this.handleError<Learner>('updateLearner'))
    )
  }
  
  deleteLearner (id: number): Observable<Learner> {
    const url = `${apiUrl}/DeleteLearnerById/${id}`;
    return this.http.delete<Learner>(url, httpOptions).pipe(
      tap((ProjectRes: Learner) => true ), //console.log()),
      catchError(this.handleError<Learner>('deleteLearner'))
    )
  }
  
}